import { observer } from "mobx-react";
import { SendWireBaseStore } from "../stores";
import { Grid } from "@material-ui/core";
import { WireDetails } from "./wireDetails";
import { BankInformation } from "./bankInformation";
import { Alert, AlertTitle } from "@material-ui/lab";
import { ERROR_STATUSES } from "./sendWireStepper";

export interface SendWireSecondStepProps {
  store: SendWireBaseStore;
}

export const SendWireSecondStep = observer((props: SendWireSecondStepProps) => {

  const { store } = props;

  return (
    <Grid container spacing={2} justifyContent="flex-end">
      <Grid item md={6} xs={12}>
        <BankInformation />
      </Grid>
      <Grid item md={6} xs={12}>
        <WireDetails />
      </Grid>
      {store?.wireInfo?.error && ERROR_STATUSES.includes(store?.wireInfo?.status) &&
        <Grid item xs={12}>
          <Alert severity="error">
            <AlertTitle>Wire Error</AlertTitle>
            {store?.wireInfo?.error}
          </Alert>
        </Grid>
      }
    </Grid>
  )
});